import PropTypes from 'prop-types';

import { getPagePath, trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { Collapsible } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import CopyWithInterpolatedLink from '@spotahome/ui-library/src/tenant/components/CopyWithInterpolatedLink';

import './ContactUsHelp.scss';

const ContactUsHelp = ({ helpCenterArticles = [] }) => {
  const getArticleList = () =>
    helpCenterArticles.map(({ id, title }) => {
      return (
        <li key={id}>
          <a href={getPagePath(id)} target="_blank" rel="noreferrer">
            {trans(title)}
          </a>
        </li>
      );
    });

  const handleOnHelpCenterClick = event => {
    event.stopPropagation();
    SoyuzAnalytics.sendGA4Event('send', {
      action: 'support-help-center'
    });
  };

  return (
    <div className="contact-us-help">
      <div className="contact-us-help__clarification">
        <div className="contact-us-help__icon">
          <DSIcon name="support_agent" size="ml" />
        </div>
        <div>{trans('contact-us.help-clarification.response-time')}</div>
      </div>

      <div className="contact-us-help__clarification">
        <div className="contact-us-help__icon">
          <DSIcon name="language" size="ml" />
        </div>
        <div>{trans('contact-us.help-clarification.spoken-languages')}</div>
      </div>

      {helpCenterArticles && !!helpCenterArticles.length ? (
        <Collapsible
          hasIcon
          renderHeader={() => (
            <div className="contact-us-help__clarification contact-us-help__clarification--is-last">
              <div className="contact-us-help__icon">
                <DSIcon name="map" size="ml" />
              </div>
              <div>
                <CopyWithInterpolatedLink
                  mainCopy={trans(
                    'contact-us.help-clarification.help-guide.main'
                  )}
                  linkCopy={trans(
                    'contact-us.help-clarification.help-guide.link'
                  )}
                  link={getPagePath('externals.help-center')}
                  linkTarget="_blank"
                  linkBold
                  onClick={handleOnHelpCenterClick}
                />
              </div>
            </div>
          )}
          renderBody={() => (
            <ul className="contact-us-help__article-list-hint">
              {getArticleList()}
            </ul>
          )}
        />
      ) : (
        <div className="contact-us-help__clarification contact-us-help__clarification--is-last">
          <div className="contact-us-help__icon">
            <DSIcon name="map" size="ml" />
          </div>
          <CopyWithInterpolatedLink
            mainCopy={trans('contact-us.help-clarification.help-guide.main')}
            linkCopy={trans('contact-us.help-clarification.help-guide.link')}
            link={getPagePath('externals.help-center')}
            linkTarget="_blank"
            linkBold
            onClick={handleOnHelpCenterClick}
          />
        </div>
      )}
    </div>
  );
};

ContactUsHelp.propTypes = {
  helpCenterArticles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  )
};

export default ContactUsHelp;
